// extracted by mini-css-extract-plugin
module.exports = {"h2":"h2__1v85i","form-submit-button":"form-submit-button__MWbs4","button":"button__3s8d7","disabled":"disabled__1zSap"};